import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { CompanyService } from 'app/services/company.service';

export function companyFilterInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const companyService = inject(CompanyService);
    
    // Get the selected company ID
    const selectedCompanyId = companyService.getSelectedCompanyId();
    
    // If a company is selected, add it to the request headers
    if (selectedCompanyId) {
        const modifiedReq = req.clone({
            setHeaders: {
                'X-Company-ID': selectedCompanyId.toString()
            }
        });
        return next(modifiedReq);
    }
    
    return next(req);
}
